




















import { Component, Vue } from 'vue-property-decorator';
import Panel from '@/components/Panel.vue';
import { ContractService } from '@/services/ContractService';
import { StateManager } from '@/services/StateManager';
import { Loader } from '@/services/Loader.ts';
import * as Helper from '@/helpers/Utils.ts';

@Component({
  components: {
    Panel,
  },
  mounted() {
    Loader.GetInstance().LoadApp();
  },
})
export default class Generate extends Vue {
  private ADDRESS_ROPSTEN = '0x1988a16caa08e4908c15de8ff37e21aed2904c20';
  private ADDRESS_MAINNET = '0x1988a16caa08e4908c15de8ff37e21aed2904c21';

  private state = StateManager.GetInstance().GetState();
  private network: string = this.state.contractAddress === this.ADDRESS_ROPSTEN ? 'ropsten' : 'mainnet';

  public changed() {
    StateManager.GetInstance().ResetState();

    switch (this.network) {
      case 'ropsten':
        this.state.contractAddress = this.ADDRESS_ROPSTEN;
        break;
      case 'mainnet':
        this.state.contractAddress = this.ADDRESS_MAINNET;
        break;
    }

    this.state.appLoaded = false;
    Loader.GetInstance().LoadApp();
  }
}
